import { Component, OnInit, OnDestroy, ViewEncapsulation, ChangeDetectionStrategy, Input } from '@angular/core';
import { EngineState } from 'src/app/engine/state/engine.state';
import { Observable, Subject } from 'rxjs';
import { Select } from '@ngxs/store';
import { takeUntil, filter } from 'rxjs/operators';
import { AnimationService } from 'src/app/engine/animation.service';
import { TimerangeModel } from 'src/app/engine/models/animation/timerange.model';
import { StoryChaptersState } from 'src/app/story/state/chapters/story.chapters.state';
import { ViewService } from '../../view.service';

@Component({
  selector: 'app-view-media-bar',
  templateUrl: './view-media-bar.component.html',
  styleUrls: ['./view-media-bar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None
})
export class ViewMediaBarComponent implements OnInit, OnDestroy {
  @Select(EngineState.getAnimationPlaying)
  animationPlaying$: Observable<boolean>;

  @Select(StoryChaptersState.getSelectedChapterId)
  selectedChapterId$: Observable<string>;

  @Input()
  showScrubber = true;

  ngUnsubscribe = new Subject();
  timerange: TimerangeModel;

  constructor(
    private animationService: AnimationService,
    private viewService: ViewService
  ) { }

  ngOnInit() {
    this.initChapterListener();
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  initChapterListener() {
    this.selectedChapterId$.pipe(
      filter(chapterId => chapterId != null),
      takeUntil(this.ngUnsubscribe)
    ).subscribe((chapterId) => {
      this.timerange = this.animationService.getChapterLocalTimerange(chapterId);
    });
  }

  handlePlayClick() {
    this.viewService.toggleAnimation();
  }
}
